import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { TEMPLATES_TURNOS } from '../constants/horarioConstants';

/**
 * Menu rápido para seleção de turnos
 * Aparece quando o utilizador clica numa célula do horário
 */
const HorarioQuickMenu = ({ 
  position, 
  data, 
  onClose, 
  onSelectTemplate,
  onOpenFullModal 
}) => {
  const [isTroca, setIsTroca] = useState(false);
  
  if (!position || !data) return null;

  const handleTemplateClick = (template) => {
    // Passar info de troca junto com o template
    onSelectTemplate({ ...template, e_troca: isTroca }, data);
    onClose();
  };

  const handleCustomClick = () => {
    onOpenFullModal(data);
    onClose();
  };

  return (
    <div
      className="fixed z-50 bg-white rounded-lg shadow-2xl border-2 border-cyan-500 p-2 min-w-[200px]"
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`
      }}
    >
      <div className="flex items-center justify-between mb-2 pb-2 border-b">
        <span className="text-sm font-semibold text-gray-700">Menu Rápido</span>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={16} />
        </button>
      </div>

      {/* Checkbox de Troca */}
      <div className="mb-2 p-2 bg-orange-50 border border-orange-300 rounded">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={isTroca}
            onChange={(e) => setIsTroca(e.target.checked)}
            className="w-4 h-4 cursor-pointer"
          />
          <span className="text-xs font-medium text-orange-900">
            🔄 Troca
          </span>
        </label>
      </div>

      <div className="space-y-1">
        {TEMPLATES_TURNOS.map(template => (
          <button
            key={template.id}
            onClick={() => handleTemplateClick(template)}
            className="w-full text-left px-3 py-2 rounded hover:bg-gray-100 transition-colors text-sm font-medium"
          >
            {template.nome}
          </button>
        ))}
        
        <div className="border-t pt-1 mt-1">
          <button
            onClick={handleCustomClick}
            className="w-full text-left px-3 py-2 rounded hover:bg-cyan-100 transition-colors text-sm font-medium text-cyan-700"
          >
            ⚙️ Personalizar Turno
          </button>
        </div>
      </div>
    </div>
  );
};

export default HorarioQuickMenu;
